(() => {
  if (window.yahavSizeGuide) return;
  window.yahavSizeGuide = true;

  const init = (root) => {
    if (!root || root.dataset.ysgReady) return;
    root.dataset.ysgReady = 'true';
    const track = root.querySelector('[data-ysg-track]');
    const cards = [...root.querySelectorAll('[data-ysg-value]')];
    const dots = [...root.querySelectorAll('[data-ysg-dot]')];
    const optionName = root.dataset.optionName;

    const centre = (card, smooth) => track.scrollTo({ left: card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2, behavior: smooth ? 'smooth' : 'auto' });
    const markDots = () => {
      const middle = track.scrollLeft + track.clientWidth / 2;
      let closest = 0;
      cards.forEach((card, i) => { if (Math.abs(card.offsetLeft + card.offsetWidth / 2 - middle) < Math.abs(cards[closest].offsetLeft + cards[closest].offsetWidth / 2 - middle)) closest = i; });
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === closest));
    };
    const select = (value) => cards.forEach((card) => {
      const on = card.dataset.ysgValue === value;
      card.classList.toggle('is-selected', on);
      card.setAttribute('aria-pressed', String(on));
    });

    cards.forEach((card) => card.addEventListener('click', () => {
      select(card.dataset.ysgValue);
      centre(card, true);
      document.dispatchEvent(new CustomEvent('yahav:select-option', { detail: { optionName, value: card.dataset.ysgValue } }));
    }));
    document.addEventListener('yahav:variant-change', (event) => {
      const variant = event.detail?.variant;
      if (!variant) return;
      const value = variant.options.find((o) => cards.some((c) => c.dataset.ysgValue === o));
      if (!value) return;
      select(value);
      const card = cards.find((c) => c.dataset.ysgValue === value);
      if (card) centre(card, true);
    });
    track.addEventListener('scroll', () => requestAnimationFrame(markDots), { passive: true });

    // Open on the middle of the range (or the popular size); a size chosen in the link wins.
    const linked = new URL(window.location.href).searchParams.has('variant') && cards.find((c) => c.classList.contains('is-selected'));
    const start = linked || cards.find((c) => c.classList.contains('is-popular')) || cards[Math.floor((cards.length - 1) / 2)];
    if (start) requestAnimationFrame(() => { centre(start, false); markDots(); });
  };
  document.querySelectorAll('[data-size-guide]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-size-guide]')));
})();
